/* eslint-disable no-undef */
export const serverUrl = process.env['REACT_APP_SERVER_URL'];
export const frontendUrl = process.env['REACT_APP_FRONTEND_URL'];
export const environment = process.env['NODE_ENV'];
export const maintenanceMode = process.env['REACT_APP_MAINTENANCE_MODE'];
export const maintenanceReason = process.env['REACT_APP_MAINTENANCE_REASON'];
export const allowGeneralRegistration = process.env['REACT_APP_GENERAL_REGISTRATION'] === 'true';
